import React from 'react';
import PropTypes from 'prop-types';

import {Button, Icon} from 'components/layout';
import AddressComplete from './AddressComplete';
import Dealer from 'models/dealer';
import {FormattedMessage} from 'react-intl';

class LayoutAddressComplete extends React.PureComponent {
  static propTypes = {
    condition: PropTypes.bool,
    dataChanged: PropTypes.func,
    dataKey: PropTypes.string,
    dirtied: PropTypes.number,
    disabled: PropTypes.any,
    editMode: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    unit: PropTypes.string,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
    value: PropTypes.any,
    group: PropTypes.object,
    required: PropTypes.bool,
    noLabel: PropTypes.bool,
    verified: PropTypes.bool,
    style: PropTypes.object,
    dealer: PropTypes.instanceOf(Dealer).isRequired,
  };

  static defaultProps = {
    condition: true,
    editMode: true,
    disabled: false,
    label: '',
    dataKey: '',
    unit: null,
  };

  state = {
    verified: !!this.props.verified,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.verified !== this.props.verified) {
      this.setState({verified: nextProps.verified});
    }
  }

  getValue = () => {
    return this.inner.getWrappedInstance().getValue();
  };

  focus = () => {
    this.inner.getWrappedInstance().focus();
  };

  setVerified = (verified) => {
    this.setState({verified});
  };

  render() {
    let disabled = this.props.disabled;

    if (disabled instanceof Array) {
      disabled = disabled.indexOf(this.props.dataKey) !== -1;
    }
    if (this.props.condition) {
      return <div className='form-group'
                  style={this.props.style}>
        {!this.props.noLabel ?
          <label style={{width: '100%'}}>
            {this.props.label}{this.props.required && this.props.editMode ?
              <span className='error'
                  style={{marginLeft: 2}}>*</span> :
            null}
            {!this.state.verified ?
              <Icon name='attention' className='error'/> :
              null}
            {this.props.editMode && !this.state.verified ?
              <Button link className='pull-right' onClick={this.focus}><FormattedMessage id='general.verify' /></Button> :
              null}
          </label> :
          null}
        <AddressComplete ref={r => this.inner = r}
                         {...this.props}
                         id='address'
                         value={this.props.value}
                         setVerified={this.setVerified}
                         country={this.props.dealer.country}
                         disabled={disabled}/>
      </div>;
    }

    return null;
  }
}

export default LayoutAddressComplete;
